module.exports = __webpack_public_path__ + "images/influencer-ca13995cb9c7c084886fe00fde024d21.png";